<template>
  <div class="row">
    <div class="col-md-12">
      <generic-user-info v-model="model"></generic-user-info>
    </div>
  </div>
</template>

<script>
import GenericUserInfo from "../../../../components/shared/GenericUserInfo.vue";

export default {
  name: "LoginCredentials",
  components: {GenericUserInfo},
  props: {
    value: {
      type: [Object],
      required: true,
    },
  },
  data() {
    return {
      model: {...this.value},
    };
  },
  watch: {
    model: {
      deep: true,
      handler(value) {
        this.$emit('input', value);
      }
    }
  }
}
</script>

<style scoped>
.col-md-12 >>> h6 {
  color: #475e72 !important;
  font-size: 16px !important;
  font-weight: bold !important;
  margin-bottom: 0;
}
</style>